module.exports = __webpack_public_path__ + "static/media/hustle_2.4b844245.svg";